export enum WebsiteConfigTag {
  AwardsVideo = "awards-video",
}
